export default __webpack_public_path__ + "static/media/03_malina.98a2a0ab.jpg";